import React, { FunctionComponent } from 'react'
import { Table } from 'semantic-ui-react';
import { StorePercentageTableRowProps } from '../../../interfaces/props/dashboards/store-percentage-table-props'

export const StorePercentageTableRow: FunctionComponent<StorePercentageTableRowProps> = (props) => (
  <Table.Row className={'clickable'} onClick={() => props.openStoreModal({ storeId: props.store.storeId, storeCode: props.store.storeCode, storeName: props.store.storeName })}>
    <Table.Cell>{`${props.store.storeId} ${props.store.storeCode} ${props.store.storeName}`}</Table.Cell>
    <Table.Cell>{props.store.ratio}</Table.Cell>
    <Table.Cell>{props.store.orderCount}</Table.Cell>
    <Table.Cell>{props.store.riderCount}</Table.Cell>
    <Table.Cell>{props.store.insiderCount}</Table.Cell>
  </Table.Row>
);
